import React, {  } from 'react';
import ArchiveItemCard from '../Gift/ArchiveItemCard';
import useGlobal from '../../store';

const MyArchive = (props) => {

    const [myarchive] = useGlobal(
        state => state.myarchive
    );

    const archive = myarchive.map(gift => <ArchiveItemCard key={gift.itemID} {...gift}></ArchiveItemCard>);

    return (
        <>
            <div className="kt-portlet">
                <div className="kt-portlet__head kt-portlet__head--lg">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-heading kt-heading--lg">Archived Gifts from Previous Years</h3>
                    </div>
                </div>
   
                <div className="kt-portlet__body">
                    {archive}
                </div>

            </div>
        </>
    );
}
export default MyArchive;